import React from 'react';
import InlineEmpty from '../InlineEmpty/InlineEmpty';
import StatusBadge from '../StatusBadge/StatusBadge';
import { agoText, describeInstant, formatDate } from './time';
import { useI18n } from '../../i18n/I18nContext';
import './Student360.css';

const TICKET_TONE = {
  OPEN: 'warning',
  IN_PROGRESS: 'info',
  WAITING_USER: 'neutral',
  RESOLVED: 'success',
  CLOSED: 'success',
};
const PRIORITY_TONE = { HIGH: 'warning', URGENT: 'danger' };

/**
 * The support tickets of the student: subject and status only. The messages are never part of the
 * response, so there is nothing here to open. A card of the page's right rail.
 */
function TicketsSection({ tickets, now }) {
  const { t, lang } = useI18n();
  const items = tickets.items || [];

  return (
    <section className="section-card s360-rail-card" aria-labelledby="s360-tickets-title">
      <div className="section-head">
        <h2 id="s360-tickets-title" className="section-head__title" title={t('student360.tickets.title')}>
          {t('student360.tickets.short')}
        </h2>
        <span className="ui-count ui-count--brand" title={t('student360.tickets.open', { count: tickets.open ?? 0 })}>
          {tickets.open ?? 0}
        </span>
      </div>
      {items.length === 0 ? (
        <InlineEmpty kind="support" title={t('student360.tickets.none')} />
      ) : (
        <ul className="s360-list">
          {items.map((ticket) => (
            <li key={ticket.id} className="s360-item">
              <div className="s360-item__main">
                <span className="s360-item__title" title={ticket.subject}>{ticket.subject}</span>
                <span className="s360-item__sub">
                  {t(`student360.tickets.category.${ticket.category}`)}
                  {' · '}
                  {formatDate(ticket.createdAt, lang)}
                  {ticket.assignee ? ` · ${ticket.assignee.name}` : ''}
                </span>
              </div>
              <div className="s360-item__side">
                {PRIORITY_TONE[ticket.priority] && (
                  <StatusBadge tone={PRIORITY_TONE[ticket.priority]}>
                    {t(`student360.tickets.priority.${ticket.priority}`)}
                  </StatusBadge>
                )}
                <StatusBadge tone={TICKET_TONE[ticket.status] || 'neutral'}>
                  {t(`student360.tickets.status.${ticket.status}`)}
                </StatusBadge>
                <span className="s360-item__date">
                  {agoText(t, describeInstant(ticket.lastMessageAt, now))}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

export default TicketsSection;
